// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Pagination/Pagination.less
// module id = 222
// module chunks = 2